var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-item"},[_c('router-link',{staticClass:"p-2",attrs:{"to":_vm.url}},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticStyle:{"width":"68px"},domProps:{"innerHTML":_vm._s(_vm.methodColor(_vm.method))}}),_c('div',{staticClass:"whitespace-no-wrap"},[_vm._v(_vm._s(_vm.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }